<template>
  <div class="ranking-table">
    <Swiper
        :modules="swiperModules"
        :slides-per-view="'auto'"
        :space-between="0"
        :speed="400"
        :threshold="5"
        :free-mode="{ enabled: true, sticky: true }"
        @touchEnd="handleScroll"
    >
      <SwiperSlide v-for="(group, groupIndex) in filteredTarotBoxes" :key="groupIndex">
        <div class="panel">
          <RankingSingleItem
              v-for="(item, index) in group"
              :key="item.id"
              :selectedCategory="selectedCategory"
              :item="item"
              :itemIndex="groupIndex * 3 + index + 1"/>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import RankingSingleItem from "@/tarot_box/pages/home/components/main_ranking/RankingSingleItem.vue"
import {Swiper, SwiperSlide} from 'swiper/vue';
import {FreeMode} from 'swiper/modules';
import {logEvent} from "@/tarot_box/helper/native_api";

import 'swiper/css';

export default {
  name: "RankingItems",
  components: {
    RankingSingleItem,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperModules: [FreeMode],
      hasSwiped: false,
    };
  },
  props: {
    selectedCategory: String
  },
  computed: {
    ...mapGetters(['tarotBoxes']),
    filteredTarotBoxes() {
      let sortedBoxes = this.selectedCategory === '종합'
          ? this.tarotBoxes.slice()
          : this.tarotBoxes.filter(item => {
            const subjects = item.subjectTitle.split(',').map(s => s.trim());
            return subjects.includes(this.selectedCategory);
          });
      sortedBoxes.sort((a, b) => b.rankingScore - a.rankingScore);
      sortedBoxes = sortedBoxes.slice(0, 9);

      const groupedBoxes = [];
      for (let i = 0; i < sortedBoxes.length; i += 3) {
        groupedBoxes.push(sortedBoxes.slice(i, i + 3));
      }

      return groupedBoxes;
    },
  },
  methods: {
    handleScroll() {
      if (!this.hasSwiped) {
        this.hasSwiped = true;
        logEvent('home_rank_list_swipe', {
          category_name: this.selectedCategory,
        });
      }
    }
  }
}

</script>

<style scoped>
.ranking-table{
  width: 100vw;
  margin-top: 20px;
}

:deep(.swiper-slide) {
  width: auto !important;
}
</style>
